import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SUPPORT_PHONE_DISPLAY } from "../constants/contact";
import { trackLeadSubmission } from "../utils/conversionTracking";
import { submitLead } from "../utils/leadSubmission";

const initialFormData = {
  name: "",
  email: "",
  phone: "",
};

const LeadForm = ({
  title = "Get Unlimited IT Assist",
  subtitle = "for as little as $19/month",
  source = "website",
  compact = false,
  buttonClassName = "",
  submitLabel = "Submit",
  submittingLabel = "Submitting...",
  redirectOnSubmit = true,
  onSubmitted,
}) => {
  const [formData, setFormData] = useState(initialFormData);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const isCallSubmit = submitLabel.toLowerCase().includes("call");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");

    try {
      const lead = await submitLead({
        type: "lead",
        source,
        ...formData,
      });

      setFormData(initialFormData);
      trackLeadSubmission({ source, type: lead.type });
      onSubmitted?.(lead);
      if (redirectOnSubmit) {
        navigate("/thankyou", { state: lead });
      }
    } catch {
      setError("We could not submit your request. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="php-email-form">
      {(title || subtitle) && (
        <div className={compact ? "" : "row"}>
          {title && <h4>{title}</h4>}
          {subtitle && <p>{subtitle}</p>}
        </div>
      )}
      <div className="inputBox form-group">
        <input
          type="text"
          name="name"
          placeholder="Your name..."
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>
      <div className="inputBox form-group">
        <input
          type="email"
          name="email"
          placeholder="Your email..."
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className="inputBox form-group">
        <input
          type="tel"
          name="phone"
          placeholder="Your phone..."
          value={formData.phone}
          onChange={handleChange}
          required
        />
      </div>
      {error && <p className="text-danger">{error}</p>}
      <div className="inputBox">
        <button
          type="submit"
          className={`${buttonClassName} ${
            isCallSubmit ? "lead-call-submit-button" : ""
          }`.trim()}
          disabled={isSubmitting}
          data-conversion-event={
            isCallSubmit ? "phone_call_click" : "lead_form_submit"
          }
          data-lead-source={source}
        >
          {isSubmitting ? submittingLabel : submitLabel}
          {isCallSubmit && (
            <span className="lead-form-call-number">
              {SUPPORT_PHONE_DISPLAY}
            </span>
          )}
        </button>
      </div>
    </form>
  );
};

export default LeadForm;
